// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"0135643e","361":"368e8a26","673":"357173e8","820":"06408098"}[chunkId] + ".chunk.js";
};